import { useMemo } from 'react'
import { useBranchLoaders } from '../../../../../modules/manager'
import { addressHelpers } from '../../../../address'

export const PDFBranchesFooter = () => {
    const { describeAddress } = addressHelpers

    const branchLoaders = useBranchLoaders()

    const branchesInfo = useMemo(() => branchLoaders().findAllBranches().map(branch => {
        const mailInfo = branch.email ? ` - Mail: ${branch.email}` : ''
        return `Sucursal ${branch.name}: ${describeAddress(branch.address)}${mailInfo}`
    }), [])

    return <>
        {branchesInfo.map((branchInfo, index) => (
            <span key={index}>{branchInfo}</span>
        ))}
    </>
}
